import { Component, OnInit, Input, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { Location, isPlatformBrowser } from '@angular/common';
import { ModalService } from '../../../Services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '../../../Services/lang/lang.service';
import { AnalyticsService } from '../../../Services/analytics/analytics.service';
import { EmojiService } from '../../../Services/emoji/emoji.service';


@Component({
  selector: 'app-activity-indicator',
  templateUrl: './activity-indicator.component.html',
  styleUrls: ['./activity-indicator.component.scss']
})
export class ActivityIndicatorComponent implements OnInit, OnDestroy {

  @Input() requestStatus;
  @Input() requestCanceled;
  @Input() type;
  @Input() isSameTrip;
  public requestState;
  public isTripPage = false;
  private requestStatusSubscription;
  private langSubscriber;
  public currentLang;
  private totalFrames = 20;
  private animationDuration = 3800;
  private timePerFrame = this.animationDuration / this.totalFrames;
  private timeWhenLastUpdate;
  private timeFromLastUpdate;
  private frameNumber = 1;
  private textTotalFrames = 21;
  private textAnimationDuration = 12000;
  private textTimePerFrame = this.textAnimationDuration / this.textTotalFrames;
  private textTimeWhenLastUpdate;
  private textTimeFromLastUpdate;
  private textFrameNumber = 1;
  private animationFrameId;
  public tnfEmoji;

  constructor(
    private modalService: ModalService,
    public translate: TranslateService,
    private location: Location,
    @Inject(PLATFORM_ID) private platform: Object,
    private lang: LangService,
    private analytics: AnalyticsService,
    private emoji: EmojiService) { }


  ngOnInit() {
    if (this.requestStatus) {
      this.requestStatusSubscription = this.requestStatus.subscribe((state) => {
        this.requestState = state;
        if (this.requestState === 2) {
          this.analytics.logEvent('trip_not_found');
        }
      });
    }
    this.langSubscriber = this.lang.cl.subscribe( res => {
      this.currentLang = res;
    });
    this.checkCurrentRoute();
    this.animationFrameId = requestAnimationFrame(this.step.bind(this));
    this.tnfEmoji = this.emoji.getEmoji('🤔');
  }

  checkCurrentRoute() {
    if (isPlatformBrowser(this.platform)) {
      this.isTripPage = location.href.indexOf('/trips') > -1;
    }
  }

  cancelRequestandClose() {
    // should cancel the request of lucky
    if (this.requestCanceled) {
      this.requestCanceled.next(true);
    }
    this.closeActivityIndicator();
  }

  closeActivityIndicator() {
    this.modalService.destroy();
  }

  // 'step' function will be called each time browser rerender the content
  // we achieve that by passing 'step' as a parameter to 'requestAnimationFrame' function
  step(startTime) {
    this.globeAnimation(startTime);
    this.textAnimation(startTime);
    this.animationFrameId = requestAnimationFrame(this.step.bind(this));
  }


  globeAnimation(startTime) {
    // 'startTime' is provided by requestAnimationName function, and we can consider it as current time
    // first of all we calculate how much time has passed from the last time when frame was update
    if (!this.timeWhenLastUpdate) {
      this.timeWhenLastUpdate = startTime;
    }
    this.timeFromLastUpdate = startTime - this.timeWhenLastUpdate;

    // then we check if it is time to update the frame
    if (this.timeFromLastUpdate > this.timePerFrame) {
      // hide all frames
      jQuery('.globe').css('opacity', 0);
      // and show the required one
      jQuery(`.globe.globe-${this.frameNumber}`).css('opacity', 1);
      // reset the last update time
      this.timeWhenLastUpdate = startTime;

      // then increase the frame number or reset it if it is the last frame
      if (this.frameNumber >= this.totalFrames) {
        this.frameNumber = 1;
      } else {
        this.frameNumber = this.frameNumber + 1;
      }
    }
  }

  textAnimation(startTime) {
    // 'startTime' is provided by requestAnimationName function, and we can consider it as current time
    // first of all we calculate how much time has passed from the last time when frame was update
    if (!this.textTimeWhenLastUpdate) {
      this.textTimeWhenLastUpdate = startTime;
    }
    this.textTimeFromLastUpdate = startTime - this.textTimeWhenLastUpdate;

    // then we check if it is time to update the frame
    if (this.textTimeFromLastUpdate > this.textTimePerFrame) {
      // hide all frames
      jQuery('.globeText').css('opacity', 0);
      // and show the required one
      jQuery(`.globeText.globeText-${this.textFrameNumber}`).css('opacity', 1);
      // reset the last update time
      this.textTimeWhenLastUpdate = startTime;

      // then increase the frame number or reset it if it is the last frame
      if (this.textFrameNumber >= this.textTotalFrames) {
        this.textFrameNumber = 1;
      } else {
        this.textFrameNumber = this.textFrameNumber + 1;
      }
    }
  }


  ngOnDestroy(): void {
    if (this.requestStatusSubscription) {
      this.requestStatusSubscription.unsubscribe();
    }
    if (this.langSubscriber) {
      this.langSubscriber.unsubscribe();
    }
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    // cancelAnimationFrame(globalID);
  }

}
